export default "__VITE_ASSET__Do0EO2dv__"